import { render } from "./ZoneOrange.vue?vue&type=template&id=b62a635e&scoped=true"
import script from "./ZoneOrange.vue?vue&type=script&lang=js"
export * from "./ZoneOrange.vue?vue&type=script&lang=js"

import "./ZoneOrange.vue?vue&type=style&index=0&id=b62a635e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b62a635e"]])

export default __exports__